<template>
  <div class="receive-detail-drawer">
    <finance-drawer
      title="应收单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="receiveNo"
      :modal-close="false"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <el-button
          class="table-button table-button-primary"
          v-if="showAddBtn()"
          @click="handleAddReceipt"
          v-track
          trackCode="receivablesReceiveList-4"
        >
          添加收款
        </el-button>
      </div>
      <div v-loading="loading">
        <!-- 应收单详情 -->
        <div class="main-cont">
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="detailInfo.receiveStatus | setStatusColor('cancelStatus')"
                :status="detailInfo.receiveStatusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo" />
              <jr-col :data-show="secondCol" :data="detailInfo">
                <template #shouldRecAmount>
                  <span>
                    {{ detailInfo.shouldRecAmount | toFenThousandsAndFloat('¥') }}
                  </span>
                  <span style="color: #407DFF;cursor: pointer;" @click="handleLogList" v-if="operationLogList.length">
                    <i class="el-icon-warning-outline" />
                  </span>
                </template>
              </jr-col>
              <jr-col :data-show="thirdCol" :data="detailInfo">
                <template #waitDivideAmount>
                  <!-- divideFlag 0-不分账，1-分账 -->
                  <div v-if="detailInfo.divideFlag === 1">{{detailInfo.waitDivideAmount | toFenThousandsAndFloat}}</div>
                  <div v-else>无需分账</div>
                </template>
              </jr-col>
            </el-row>
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的收款单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.receiveRecords || [])"
              :tableColumn="receiveRecordsColumn"
            />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的付款单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.paymentRecords || [])"
              :tableColumn="paymentRecordsColumn"
            />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的分账申请</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.divideRecords || [])"
              :tableColumn="subAccountRecordsColumn"
            >
              <template v-slot:divideDetail="{row}">
                <div v-for="(item, dIndex) in row.divideDetail || []" :key="dIndex">
                  {{item.businessName || '-'}}：{{item.divideAmount | toFenThousandsAndFloat}}
                </div>
              </template>
            </jr-table>
          </div>
        </div>
      </div>
    </finance-drawer>
    <!-- 收款单详情 -->
    <receipt-detail
      v-if="isReceiptDetailShow"
      :visible.sync="isReceiptDetailShow"
      :receipt-no.sync="receiptNo"
    />
    <!-- 付款单详情 -->
    <payment-detail
      v-if="isPaymentDetailShow"
      :visible.sync="isPaymentDetailShow"
      :payment-no.sync="paymentNo"
    />
    <!-- 应付单详情 -->
    <payable-detail
      v-if="isPayableDetailShow"
      :visible.sync="isPayableDetailShow"
      :payable-no.sync="payableNo"
    />
    <!-- 添加收款 -->
    <receipt-dialog
      :visible.sync="isAddReceipt"
      :receipt-data="detailInfo"
      @success="getReceiveDetail"
    />
    <!-- 操作日志 -->
    <operationLogList :visible.sync="isOperationLogShow" :list="operationLogList" />
  </div>
</template>

<script>
/**
 * 应收单详情
 * 权限值 FWS-SFKGL-YSD-XQ
 */
import { getReceiveDetail, getOperationLogList } from '@/api/receivables/receive';
import { setStatusColor } from '@/filters/index';
import receiptDialog from '../receive/components/receipt-dialog';
import operationLogList from '@/components/pageComponents/operationLogList';

export default {
  name: 'ReceiveDetail',
  props: {
    receiveNo: {
      type: String,
      default: '',
    },
  },
  components: {
    // 循环引用组件采用异步import
    receiptDetail: () => import('./receipt-detail'),
    paymentDetail: () => import('../payment/components/detail'),
    payableDetail: () => import('./payment-payable-detail'),
    receiptDialog,
    operationLogList,
  },
  data() {
    return {
      detailInfo: {},
      loading: false,
      /** -----收款单详情----- */
      receiptNo: '',
      isReceiptDetailShow: false,
      paymentNo: '',
      isPaymentDetailShow: false,
      payableNo: '',
      isPayableDetailShow: false,
      // 基础信息
      firstCol: [
        { label: '客户名称:', prop: 'recBusinessName' },
        { label: '客户编号:', prop: 'recBusinessNo' },
        { label: '应收类型:', prop: 'typeDesc' },
        { label: '业务订单号:', prop: 'orderNumber' },
        { label: '收款状态:', prop: 'paymentStatusDesc' },
        { label: '业务类型:', prop: 'busiTypeDesc' },
      ],
      secondCol: [
        { label: '应收金额:', prop: 'shouldRecAmount', slotName: 'shouldRecAmount' },
        { label: '实收金额:', prop: 'realAmount', filters: 'toFenThousandsAndFloat' },
        { label: '待收金额:', prop: 'waitRecAmount', filters: 'toFenThousandsAndFloat', className: 'detail-amount_num' },
        { label: '已确认金额:', prop: 'alreadyRecAmount', filters: 'toFenThousandsAndFloat' },
        { label: '待确认金额:', prop: 'waitConfirmAmount', filters: 'toFenThousandsAndFloat' },
        { label: '已退款金额:', prop: 'refundAmount', filters: 'toFenThousandsAndFloat' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'busiSourceDesc' },
        { label: '申请人:', prop: 'cruser' },
        { label: '创建时间:', prop: 'crtime', filters: 'formatTime' },
        { label: '业务BD:', prop: 'bdName' },
        { label: '待分账金额:', prop: 'waitDivideAmount', slotName: 'waitDivideAmount' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
      ],
      isAddReceipt: false, // 添加收款
      isOperationLogShow: false,
      operationLogList: [],
    };
  },
  computed: {
    // 关联的收款单
    receiveRecordsColumn() {
      const list = [
        {
          label: '收款单编号',
          prop: 'receiptNo',
          permission: 'FWS-SFKGL-SKD-XQ',
          click: (row) => {
            this.handlerRceiptDetail(row);
          },
        },
        {
          label: '收款类型',
          prop: 'typeDesc',
        },
        {
          label: '收款方式',
          prop: 'receiptTypeDesc',
        }, {
          label: '收款单金额',
          prop: 'receiptAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '本次收款金额',
          prop: 'receiveReceiptAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '收款时间',
          prop: 'receiptTime',
          filterName: 'formatTime',
        }, {
          label: '状态',
          status: 'verifiedStatus',
          statusDesc: 'verifiedStatusDesc',
          statusColor: (val) => setStatusColor(val, 'receiptStatus'),
        },
      ];
      return list;
    },
    // 关联的付款单
    paymentRecordsColumn() {
      const list = [
        {
          label: '付款单编号',
          prop: 'paymentNo',
          permission: 'FWS-SFKGL-FKD-XQ',
          click: (row) => {
            this.handlePaymentDetail(row);
          },
        },
        {
          label: '应付单编号',
          prop: 'payableNo',
          permission: 'FWS-SFKGL-YFD-XQ',
          click: (row) => {
            this.handlePayableDetail(row);
          },
        },
        {
          label: '付款类型',
          prop: 'typeDesc',
        },
        {
          label: '付款方式',
          prop: 'payWayDesc',
        }, {
          label: '付款金额',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '付款时间',
          prop: 'payTime',
          filterName: 'formatTime',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => setStatusColor(val, 'paymentStatus'),
        },
      ];
      return list;
    },
    // 关联的分账单
    subAccountRecordsColumn() {
      const list = [
        {
          label: '分账申请编号',
          prop: 'divideApplyNo',
        },
        {
          label: '分账单号',
          prop: 'divideNo',
        },
        {
          label: '分账类型',
          prop: 'divideTypeDesc',
        },
        {
          label: '分账申请时间',
          prop: 'createTime',
          width: '115px',
          filterName: 'formatTime',
        }, {
          label: '分账金额',
          prop: 'divideAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '分账方案',
          prop: 'divideDetail',
          slotName: 'divideDetail',
        }, {
          label: '状态',
          status: 'divideStatus',
          statusDesc: 'divideStatusDesc',
          statusColor: (val) => setStatusColor(val, 'divideStatus'),
        },
      ];
      return list;
    },
  },
  watch: {
    receiveNo: {
      deep: true,
      handler() {
        if (this.receiveNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.operationLogList = [];
      this.$nextTick(async () => {
        this.isReceiptDetailShow = false;
        this.isPaymentDetailShow = false;
        this.isPayableDetailShow = false;
        await this.getReceiveDetail();
        this.getLogList();
      });
    },
    // 获取详情接口
    async getReceiveDetail() {
      try {
        this.detailInfo = {
          receiveRecords: [],
        };
        if (!this.receiveNo) {
          this.$message.warning('应收单编号不能为空！！');
          return;
        }
        this.loading = true;
        const res = await getReceiveDetail({ receiveNo: this.receiveNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    // 获取操作日志
    async getLogList() {
      try {
        const res = await getOperationLogList({ orderNumber: this.detailInfo.orderNumber });
        this.operationLogList = res.data || [];
      } catch (error) {
        console.log(error);
      }
    },
    // 查看收款单详情
    handlerRceiptDetail(row) {
      this.receiptNo = row?.receiptNo || '';
      this.isReceiptDetailShow = true;
    },
    // 付款单详情
    handlePaymentDetail(row) {
      this.paymentNo = row?.paymentNo || '';
      this.isPaymentDetailShow = true;
    },
    // 应付单详情
    handlePayableDetail(row) {
      this.payableNo = row?.payableNo || '';
      this.isPayableDetailShow = true;
    },
    showAddBtn() {
      const { waitRecAmount, paymentStatus, receiveStatus, creditOrder } = this.detailInfo;
      // 1待收款/2部分收款 && 1待核销 && 待收金额 > 0 && 非金融单 && 有权限
      const flag = [1, 2].includes(paymentStatus) && waitRecAmount > 0 && receiveStatus === 1 && !creditOrder;
      return flag && this.$has('FWS-SFKGL-YSD-TJSK');
    },
    // 添加收款
    handleAddReceipt() {
      this.isAddReceipt = true;
    },
    // 查看日志
    handleLogList() {
      this.isOperationLogShow = true;
    },
  },
};
</script>
